import type { Person } from '../../eventsApi/persons/person'
import type { User } from '../../usersApi/users/user'
import type { PaymentMethod, PaymentMethodTypeEnum } from '../payment-methods/payment-methods'
import type { Service } from '../services/service'

export class Invoice {
    invoiceId: string
    companyId: string
    personId: string
    userId: string
    status: string
    total: number
    totalPaid: number
    discountFixed: number
    discountPercentage: number
    notes: string
    createdAt: Date
    updatedAt: Date
    services: ServicesOnInvoices[]
    payments?: PaymentMethodsOnInvoices[]
    person?: Person
    user?: User
    appointmentId?: string
    cashierId?: string
    quotationId?: string
    taxInvoiceId?: string
    referralId?: string
}

export class ServicesOnInvoices {
    servicesOnInvoicesId?: string
    parentServicesOnInvoicesId?: string
    parentServiceId?: string
    userId?: string
    quantity: number
    valueTable: number
    valueGross: number
    value: number
    comissionFixed: number
    comissionPercentage: number
    comissionFeeDebt: number
    comissionFeeDebtAttendant: number
    // alguma taxa do VENDEDOR (% / fixo / custos) veio da comissão personalizada do profissional
    comissionRateCustomized?: boolean
    comissionCosts: number
    comissionCanceled: boolean
    createdAt?: Date
    updatedAt?: Date
    invoiceId?: string
    serviceId?: string
    service?: Service
    user?: User
    type: string
    fee?: number // a taxa de maquininha referente a este serviço (não precisa multiplicar pela quantidade. já é o total do item)
}

export class PaymentMethodsOnInvoices {
    paymentMethodsOnInvoicesId?: string
    installments: number
    value: number
    feePercentage: number
    createdAt?: Date
    updatedAt?: Date
    invoiceId?: string
    paymentMethodId?: string
    paymentMethod?: PaymentMethod
    firstDueInDays?: number
    feeFixed: number
    receiptType: string
    receiptInterval: number
    receiptDelay: number
    type: PaymentMethodTypeEnum
}
